module.exports = __webpack_public_path__ + "img/live-agent.bdffb1c3.png";